// src/components/LogoSection.js
import React from 'react';
import { Link } from 'react-router-dom';
// Use the new logo from public folder
const logo = '/kce-logo192.png';

const LogoSection = () => {
  const handleKjetdClick = () => {
    window.open('https://kaamadhenupublications.org/', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="container logo-section-container">
      <div className="d-flex align-items-center justify-content-between flex-wrap">
        <Link to="/" className="d-flex align-items-center logo-link-wrapper">
          <img src={logo} width="125" height="125" alt="KAAMADHENU COLLEGE OF EDUCATION" className="logo-img" />
          <div className="ml-3 logo-section-text" style={{ fontFamily: 'LOVELO, sans-serif', lineHeight: '1.1' }}>
            <span className="fs-2 font-weight-bold" style={{ color: '#002457', fontFamily: 'LOVELO, sans-serif' }} >
              KAAMADHENU COLLEGE OF EDUCATION
           </span>
            <p className="mb-0 affiliation-text" style={{ fontFamily: 'LOVELO, sans-serif' }}>
              Recognized by National Council for Teacher Education <strong>&amp;</strong> Affiliated to the Tamil Nadu Teachers Education University
            </p> 
            {/* <p className="mb-0 affiliation-text" style={{ fontFamily: 'LOVELO, sans-serif' }}>
            Approved by Govt. of Tamil Nadu, Recognised by NCTE & Affiliated to Tami Nadu Teachers Education University
             </p> */}

            <p className="mb-0 affiliation-text" style={{ fontFamily: 'LOVELO, sans-serif' }}>
              Sathyamangalam – 638503, Erode DT.
            </p>
          </div>
        </Link>
        <button 
          onClick={handleKjetdClick}
          className="btn kjetd-button"
          style={{ 
            backgroundColor: '#fda638',
            color: '#fff',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '5px',
            cursor: 'pointer',
            transition: 'background-color 0.3s ease',
            fontWeight: 'bold'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#1eaaf1'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#fda638'}
        >
          Visit KJETD <span className="animated-arrows">&gt;&gt;</span>
        </button>
      </div>
    </div>
  );
};

export default LogoSection;
